<template>
    <div class="modal-user-info" @click="onClose">
        <div class="user-info-modal-box" @click.stop="">
            <div class="user-info-header-box">
                <div class="user-info-title-box">
                    {{ $t("common.Setting") }}
                </div>
            </div>
            <div class="setting-body">
                <div class="setting-body-top">
                    <div class="language-select-panel">
                        <div
                        class="my-btn"
                            :class="{
                                'language-btn-select':
                                    $store.state.common.lang == 'en',
                                'language-btn-unselect':
                                    $store.state.common.lang != 'en',
                            }"
                            @click="onSelectLang('en')"
                        >
                            {{ $t("common.English") }}
                        </div>
                        <div
                        class="my-btn"
                            :class="{
                                'language-btn-select':
                                    $store.state.common.lang == 'ex',
                                'language-btn-unselect':
                                    $store.state.common.lang != 'ex',
                            }"
                            @click="onSelectLang('ex')"
                        >
                            {{ $t("common.language2") }}
                        </div>
                    </div>
                    <div class="split-block"></div>
                    <div class="setting-select-panel">
                        <div class="setting-item">
                            <div class="setting-item-txt">
                                {{ $t("common.BGM") }}
                            </div>
                            <div class="setting-item-btn">
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="$store.state.common.bgm"
                                    @click="onSettingBgm(0)"
                                >
                                    <div class="setting-item-btn-dot-Y"></div>
                                    <div class="setting-item-btn-txt-Y">Y</div>
                                </div>
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="!$store.state.common.bgm"
                                    @click="onSettingBgm(1)"
                                >
                                    <div class="setting-item-btn-dot-N"></div>
                                    <div class="setting-item-btn-txt-N">N</div>
                                </div>
                            </div>
                        </div>
                        <div class="setting-item">
                            <div class="setting-item-txt">
                                {{ $t("common.SFX") }}
                            </div>
                            <div class="setting-item-btn">
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="$store.state.common.sfx"
                                    @click="onSettingSFX(0)"
                                >
                                    <div class="setting-item-btn-dot-Y"></div>
                                    <div class="setting-item-btn-txt-Y">Y</div>
                                </div>
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="!$store.state.common.sfx"
                                    @click="onSettingSFX(1)"
                                >
                                    <div class="setting-item-btn-dot-N"></div>
                                    <div class="setting-item-btn-txt-N">N</div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="setting-item">
                            <div class="setting-item-txt">
                                {{ $t("common.Notice") }}
                            </div>
                            <div class="setting-item-btn">
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="$store.state.common.notice"
                                    @click="onSettingNotice(0)"
                                >
                                    <div class="setting-item-btn-dot-Y"></div>
                                    <div class="setting-item-btn-txt-Y">Y</div>
                                </div>
                                <div
                                    class="setting-item-btn-dot"
                                    v-if="!$store.state.common.notice"
                                    @click="onSettingNotice(1)"
                                >
                                    <div class="setting-item-btn-dot-N"></div>
                                    <div class="setting-item-btn-txt-N">N</div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="policy-bar">
                    <div class="policy-bar-icon-box my-btn" @click="onTC()">
                        <div class="ico ico-btn-contract"></div>
                        <div class="policy-bar-icon-txt">
                            {{ $t("common.T&C") }}
                        </div>
                    </div>
                    <div class="policy-bar-icon-box my-btn" @click="onPrivacyPolicy()">
                        <div class="ico ico-btn-private"></div>
                        <div class="policy-bar-icon-txt">
                            {{ $t("common.Privacy_Policy") }}
                        </div>
                    </div>
                    <div class="policy-bar-icon-box my-btn" @click="onRefundPolicy()">
                        <div class="ico ico-btn-refund"></div>
                        <div class="policy-bar-icon-txt">
                            {{ $t("common.Refund_Policy") }}
                        </div>
                    </div>
                </div>
                <div class="rummy-version-txt">
                    {{ $t("common.BangGames-Rummy") }}1.0.0
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { loadLanguageAsync } from "../../utils/i18n";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
export default {
    name: "Modal",
    props: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {
        onTC() {
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/TC" });
        },
        onPrivacyPolicy() {
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/privacy/policy" });
        },
        onRefundPolicy() {
            tools.emit(eventConfig.playEffect, "pop");
            tools.toPage(this, { path: "/refund/policy" });
        },
        onSelectLang(lang) {
            tools.emit(eventConfig.playEffect, "pop");
            console.log(lang);
            this.$store.commit("common/setLanguage", lang);
            loadLanguageAsync(lang);
            this.changeSetting("language", lang);
        },
        onSettingBgm(val) {
            this.$store.commit("common/setBgm", val);
            this.changeSetting("bgm", val);
            tools.emit(eventConfig.playEffect, "pop");
        },
        onSettingSFX(val) {
            this.$store.commit("common/setSfx", val);
            this.changeSetting("sfx", val);
            tools.emit(eventConfig.playEffect, "pop");
        },

        onSettingNotice(val) {
            this.$store.commit("common/setNotice", val);
            this.changeSetting("notice", val);
            tools.emit(eventConfig.playEffect, "pop");
        },
        changeSetting(key, val) {
            if (!this.$store.state.user.isLogin) {
                return;
            }
            tools.setLoadingState(true);
            ServerManager.updateUserInfo(
                this,
                key,
                val,
                (data) => {
                    tools.setLoadingState(false);
                    console.log(data);

                    if (data.result == 1) {
                        this.getUserAction();
                        this.$toast.show(this.$t("tips.save_successfully"));
                    }
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        getUserAction() {
            ServerManager.getUserInfo(
                this,
                (data) => {},
                (error) => {}
            );
        },
        onClose() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
        onOK() {
            this.$emit("on-ok");
        },
    },
};
</script>
<style>
@import "../../assets/spritesmith-generated/home.css";
@import "../../assets/css/user.css";
.setting-body {
    margin-top: 18px;
    height: 659px;
    width: 580px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.setting-body-top {
    margin-top: 11px;
    height: 400px;
    width: 580px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.language-select-panel {
    width: 270px;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.language-btn-select {
    margin-top: 40px;
    width: 170px;
    height: 63px;
    background: #000000;
    border: 3px solid #78de30;
    border-radius: 15px;
    text-align: center;
    font-size: 28px;
    font-family: Arial;
    font-weight: bold;
    color: #ffffff;
    line-height: 63px;
}
.language-btn-unselect {
    margin-top: 40px;
    width: 170px;
    height: 63px;
    background: #000000;
    border: 2px solid #575358;
    border-radius: 15px;
    text-align: center;
    font-size: 28px;
    font-family: Arial;
    font-weight: bold;

    color: #8e8d94;
    line-height: 63px;
}
.split-block {
    width: 4px;
    height: 387px;
    background: #2a2a2b;
}
.setting-select-panel {
    width: 270px;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.setting-item {
    width: 270px;
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.setting-item-txt {
    font-size: 28px;
    font-family: Arial;
    font-weight: 400;
    color: #f82e49;
    line-height: 24px;
    margin-right: 20px;
}
.setting-item-btn {
    width: 151px;
    height: 56px;
    background: #f82e49;
    border: 2px solid #000000;
    border-radius: 28px;
    position: relative;
}
.setting-item-btn-dot-Y {
    position: absolute;
    top: 7px;
    left: 8px;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 50%;
}
.setting-item-btn-dot {
    width: 151px;
    height: 56px;

    border-radius: 28px;
    position: relative;
}
.setting-item-btn-txt-Y {
    position: absolute;
    top: 15px;
    right: 12px;
    font-size: 28px;
    font-family: Arial;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
}
.setting-item-btn-dot-N {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 50%;
}
.setting-item-btn-txt-N {
    position: absolute;
    top: 15px;
    left: 12px;
    font-size: 28px;
    font-family: Arial;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
}
.policy-bar {
    margin-top: 30px;
    width: 580px;
    height: 160px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.policy-bar-icon-box {
    width: 140px;
    height: 160px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}
.policy-bar-icon-txt {
    margin-top: 10px;
    width: 130px;
    text-align: center;
    font-size: 26px;
    font-family: Arial;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
}
.rummy-version-txt {
    font-size: 22px;
    font-family: Arial;
    font-weight: 400;
    color: #d3d1d5;
    line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/rummy_setting.vue